import { RecipientType } from "models/list-schedule";
import { ListUser } from "models/list-user";

export const filterUsers = (users: ListUser[], recipients: RecipientType) => {
  switch (recipients) {
    case "all":
      return [...users];
    case "draft":
      return [...users].filter(
        (user) => user.status === "draft" || user.status === "invited",
      );
    default:
      throw new Error("Unknown recipient filter.");
  }
};
